module.exports = __webpack_public_path__ + "img/chart.d79b4cb6.svg";